import {
  CREATE_CUSTOMFIELD_START,
  CREATE_CUSTOMFIELD_ERROR,
  CREATE_CUSTOMFIELD_SUCCESS,
  CREATE_CUSTOMFIELD_RESET,
  GETLEADS_CUSTOMFIELD_START,
  GETLEADS_CUSTOMFIELD_SUCCESS,
  GETLEADS_CUSTOMFIELD_ERROR,
  GETLEADS_CUSTOMFIELD_RESET,
  UPDATE_CUSTOMFIELD_START,
  UPDATE_CUSTOMFIELD_SUCCESS,
  UPDATE_CUSTOMFIELD_ERROR,
  UPDATE_CUSTOMFIELD_RESET,
  GETCUST_CUSTOMFIELD_START,
  GETCUST_CUSTOMFIELD_SUCCESS,
  GETCUST_CUSTOMFIELD_ERROR,
  GETCUST_CUSTOMFIELD_RESET,
} from "./ActionTypes"

const initialState = {
  errors: null,
  responseMsg: null,
  loading: false,
  customFields: [],
}

const CustomFieldReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CUSTOMFIELD_START:
      return {
        ...state,
        errors: null,
        responseMsg: null,
        loading: true,
      }
    case CREATE_CUSTOMFIELD_SUCCESS:
      return {
        ...state,
        loading: false,
        responseMsg: action.payload.message,
      }
    case CREATE_CUSTOMFIELD_ERROR:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      }
    case UPDATE_CUSTOMFIELD_START:
      return {
        ...state,
        errors: null,
        loading: true,
        responseMsg: null,
      }
    case UPDATE_CUSTOMFIELD_SUCCESS:
      return {
        ...state,
        loading: false,
        responseMsg: action.payload.message,
      }
    case UPDATE_CUSTOMFIELD_ERROR:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      }
    case UPDATE_CUSTOMFIELD_RESET:
      return {
        ...state,
        errors: null,
        loading: false,
        responseMsg: null,
      }
    case CREATE_CUSTOMFIELD_RESET:
      return {
        ...state,
        errors: null,
        responseMsg: null,
        loading: false,
        customFields: [],
      }
    case GETLEADS_CUSTOMFIELD_START:
      return {
        ...state,
        loading: true,
        errors: null,
        responseMsg: null,
      }
    case GETLEADS_CUSTOMFIELD_SUCCESS:
      return {
        ...state,
        loading: false,
        customFields: action.payload.data,
        //  responseMsg: action.payload.message,
      }
    case GETLEADS_CUSTOMFIELD_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      }
    case GETLEADS_CUSTOMFIELD_RESET:
      return {
        ...state,
        errors: null,
        responseMsg: null,
      }
    case GETCUST_CUSTOMFIELD_START:
      return {
        ...state,
        loading: true,
        errors: null,
        responseMsg: null,
      }
    case GETCUST_CUSTOMFIELD_SUCCESS:
      return {
        ...state,
        loading: false,
        customFields: action.payload.data,
        //  responseMsg: action.payload.message,
      }
    case GETCUST_CUSTOMFIELD_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      }
    case GETCUST_CUSTOMFIELD_RESET:
      return {
        ...state,
        errors: null,
        responseMsg: null,
      }
    default:
      return state
  }
}

export default CustomFieldReducer
